<template>
  <div>
    <el-form label-width="80px">
      <el-form-item label="购买时长">
        <el-select v-model="optionsval" @change="optionchange" placeholder="请选择">
          <el-option v-for="(item,i) in options" :key="i" :label="item.label" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="价格">
        <el-input v-model="obj.basic_amount" @change="basic_amountchange"></el-input>
      </el-form-item>
      <el-form-item label="账号数量">
        <el-input value="1" disabled></el-input>
      </el-form-item>
      <el-form-item label="折扣提示">
        <el-input v-model="obj.discount_tips"></el-input>
      </el-form-item>
      <el-form-item label="英文提示">
        <el-input v-model="obj.discount_tips_en"></el-input>
      </el-form-item>
      <el-form-item label="截止时间">
        <el-date-picker
          v-model="obj.expiration_time"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="submitedit">确定创建</el-button>
  </div>
</template>

<script>
export default {
  data: () => ({
    optionsval: null,
    options: [
      {
        value: {
          time_value: 1,
          time_unit: 1
        },
        label: "1月"
      },
      {
        value: {
          time_value: 1,
          time_unit: 2
        },
        label: "1年"
      },
      {
        value: {
          time_value: 2,
          time_unit: 2
        },
        label: "2年"
      },
      {
        value: {
          time_value: 3,
          time_unit: 2
        },
        label: "3年"
      },
      {
        value: {
          time_value: 5,
          time_unit: 2
        },
        label: "5年"
      },
      {
        value: {
          time_value: 8,
          time_unit: 2
        },
        label: "8年"
      },
      {
        value: {
          time_value: 10,
          time_unit: 2
        },
        label: "10年"
      }
    ],
    obj: {
      basic_amount: "",
      true_amount: "",
      time_value: "",
      time_unit: "",
      discount_tips: "",
      discount_tips_en: "",
      expiration_time: ""
    }
  }),
  methods: {
    optionchange(val) {
      this.$set(this.obj, "time_value", val.value.time_value);
      this.$set(this.obj, "time_unit", val.value.time_unit);
    },
    basic_amountchange(val) {
      this.$set(this.obj, "true_amount", val);
    },
    submitedit() {
      this.$axios.post("promote-price-configs", this.obj).then(res =>
        this.$message({
          message: res.message,
          type: "success"
        }),
      );
    }
  }
};
</script>

<style>
</style>